import React from "react";
import { connect } from "react-redux";

import { ValidationError } from "../../../common/lib/validation";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input as BootstrapInput,
  FormFeedback,
  Button
} from "reactstrap";
import { setField } from "../../../common/lib/redux-fields/actions";

import DatePicker from "react-datepicker";
import Select from "react-select";

import moment from "moment";

moment.locale("pl");

class Input extends React.Component {
  constructor() {
    super();
  }

  render() {
    const {
      field,
      title,
      type,
      staticField,
      placeholder,
      loading,
      clearError,
      autoFocus,
      error,
      labelCol,
      inputCol,
      className,
      children,
      noError,
      formPath,
      setField,
      map,
      result,
      entity,
      loadOptions,
      appLoading,
      ...attrs
    } = this.props;

    let cs = className,
      showError = false;

    let elementCs = "";

    if (!staticField && ValidationError.isInvalid(error, field)) {
      showError = true;
    }

    let childs = undefined;
    let input = "";

    if (type === "select") {
      childs = children;
      elementCs += " custom-select";
    }

    if (staticField && type === "react-select-async") {
      childs = map.getIn([attrs.value, "name"]);
    } else if (staticField) {
      childs = attrs.value;
    }

    if (type === "date") {
      input = (
        <DatePicker
          className="form-control"
          dateFormat="DD/MM/YYYY"
          selected={moment(attrs.value)}
          locale="pl"
          fixedHeight
          onChange={value => {
            setField([formPath, field], value);
          }}
        />
      );
    } else if (type === "react-select-async" && !staticField) {
      let options = [];
      result &&
        result[entity] &&
        result[entity].map(r => {
          options.push({
            value: map.getIn([r, "uid"]),
            label: map.getIn([r, "name"])
          });
        });

      input = (
        <Select
          name={field}
          value={attrs.value}
          options={options}
          clearable={false}
          onInputChange={loadOptions}
          placeholder="Wybierz..."
          searchPromptText="Wpisz, aby wyszukać..."
          noResultsText="Brak wyników..."
          isLoading={options.length === 0 && appLoading}
          onChange={value => {
            setField([formPath, field], value.value);
          }}
        />
      );
    } else {
      input = (
        <BootstrapInput
          className={elementCs}
          static={staticField}
          state={ValidationError.isInvalid(error, field) ? "danger" : ""}
          type={type}
          name={field}
          id={field}
          placeholder={placeholder}
          disabled={loading}
          onFocus={clearError}
          autoFocus={autoFocus}
          {...attrs}
        >
          {childs}
        </BootstrapInput>
      );
    }

    return (
      <FormGroup
        className={cs}
        color={ValidationError.isInvalid(error, field) ? "danger" : ""}
      >
        {type !== "checkbox" && <Label for={field}>{title}</Label>}
        {input}
        {type === "checkbox" && (
          <Label className="m-l-1" for={field}>
            {title}
          </Label>
        )}
        {!noError &&
        showError && (
          <FormFeedback>{ValidationError.getError(error, field)}</FormFeedback>
        )}
      </FormGroup>
    );
  }
}

Input = connect(
  state => ({
    appLoading: state.app.appLoading
  }),
  { setField }
)(Input);

export default Input;



/** WEBPACK FOOTER **
 ** ./src/browser/components/Form/Input.js
 **/